<template>
  <hm-content title="">
    <div>当前报表：{{ reportName }}</div>
    <div class="flex item-center mb10 mt10">
      <el-date-picker
        clearable
        v-model="queryDateValue"
        type="daterange"
        value-format="yyyy-MM-dd"
        size="small"
        align="right"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        class="mr10"
        v-if="dateType"
      >
      </el-date-picker>
      <el-button type="primary" size="small" @click="search"
        >生成报表</el-button
      >
    </div>
    <div class="not-add-header">
      <div class="mb10 title">已保存布局</div>
      <div class="mb20">
        <el-button type="text" size="small" @click="go">新增模板</el-button>

        <!-- <el-button
          type="text"
          size="small"
          @click="edit"
          v-if="templateList.length"
          >编辑当前选中模板</el-button
        > -->
      </div>
      <div class="flex ">
        <el-radio-group
          v-model="selectTemplate"
          size="small"
          @change="selectTemplateChange"
        >
          <el-radio-button
            v-for="(v, i) in templateList"
            :key="i"
            :label="v"
            class="ctmd"
          >
            <div class="box flex item-center">
              <div>
                <div class="text-center">{{ v.layoutName }}</div>
                <div class="mt10">
                  {{ v.updateTime }}
                </div>
              </div>
            </div>
            <div class="edit" v-if="v.id === selectTemplate.id">
              <el-button type="text" size="small" @click="edit"
                >编辑当前模板</el-button
              >
            </div>
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="mt20">
      <el-table
        v-if="tableHeader.length"
        stripe
        border
        :data="tableData"
        style="width: 100%"
        id="table"
        size="small"
        ref="table"
        max-height="500"
      >
        <el-table-column
          header-align="center"
          align="center"
          :prop="col.columnName"
          :label="col.labelName"
          v-for="(col, index) in tableHeader"
          :column-key="col.columnName"
          :key="index"
        >
          <template v-if="col.children.length">
            <el-table-column
              v-for="(v, i) in col.children"
              :key="i"
              :column-key="v.columnName"
              header-align="center"
              align="center"
              :prop="v.columnName + col.labelName"
              :label="v.labelName"
            >
            </el-table-column>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :close-on-click-modal="false"
    >
      <div class="flex flex-center primary mb10">还没有设置报表模板</div>
      <div class="flex flex-center">
        <el-button size="small" type="primary" @click="go"
          >去设置报表模板</el-button
        >
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="info" @click="dialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      selectTemplate: {},
      activeTab: 0,
      queryDateValue: "",
      tableData: [],
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      id: this.$route.query.id,
      reportName: this.$route.query.reportName,
      templateList: [],
      tableHeader: [],
      dateTypeList: [],
      dateType: "",
      textList: [],
      valueList: [],
      dateList: [],
      calendarRange: {},
      configId: ""
    };
  },
  created() {
    this.queryComponentDataType();
  },
  mounted() {
    console.log(this.$route.query);
  },
  methods: {
    edit() {
      this.$router.push({
        name: "CustomReportTemplate",
        query: {
          id: this.id,
          row: JSON.stringify(this.selectTemplate)
        }
      });
    },
    go() {
      this.$router.push({
        name: "CustomReportTemplate",
        query: {
          id: this.id
        }
      });
    },
    selectTemplateChange(val) {
      console.log("val: ", val);
      console.log(this.selectTemplate);
      this.checkTemplate();
    },
    async search() {
      if (!this.queryDateValue || !this.queryDateValue.length > 0) {
        this.$message({
          message: "请先选择时间段",
          type: "warning"
        });
        return;
      }
      let params = {
        calType: this.dateType,
        startCalDateStr:
          this.queryDateValue && this.queryDateValue.length > 0
            ? this.queryDateValue[0]
            : "",
        endCalDateStr:
          this.queryDateValue && this.queryDateValue.length > 0
            ? this.queryDateValue[1]
            : ""
      };
      const { result } = await this.$store.dispatch(
        "queryCalendarRange",
        params
      );
      this.calendarRange = result;
      let headerList = [];
      // this.dateType = JSON.parse(JSON.stringify(tableHeader.dateType));
      // this.textList = JSON.parse(JSON.stringify(tableHeader.textList));
      // this.valueList = JSON.parse(JSON.stringify(tableHeader.valueList));
      this.textList.forEach(v => {
        v.children = [];
      });
      this.valueList.forEach(v => {
        v.children = [];
      });
      headerList.push(...this.textList);
      let valueList = [];
      result.calendarRangeList.forEach(v => {
        valueList.push({
          labelName: v,
          columnName: this.dateList[0].columnName,
          children: this.valueList
        });
      });
      // this.valueList = valueList;
      headerList.push(...valueList);
      // if (this.dateType) {
      //   let name = this.dateTypeList.find(v => v.itemValue === this.dateType);
      //   console.log("name: ", name);
      //   headerList.push({
      //     labelName: name.itemText,
      //     columnName: this.dateType,
      //     children: this.valueList
      //   });
      // } else {
      //   headerList.push(...this.valueList);
      // }

      this.tableHeader = headerList;
      console.log("this.tableHeader: ", this.tableHeader);
      this.querySsrTemplatRpteData();
    },
    async querySsrTemplatRpteData() {
      let oneValueColumnList = [];
      oneValueColumnList.push({
        calendarRange: this.calendarRange,
        columnName: this.dateType,
        twoValueColumnList: this.valueList
      });

      let params = {
        configId: this.configId,
        layoutType: "ssrTemplate",
        calendarRange: this.calendarRange,
        labelColumnList: this.textList,
        oneValueColumnList: oneValueColumnList
      };
      const { result } = await this.$store.dispatch(
        "querySsrTemplatRpteData",
        params
      );
      console.log("result: ", result);
      this.tableData = result;
      console.log("this.tableData: ", this.tableData);
    },

    async queryComponentDataType() {
      const { result } = await this.$store.dispatch("queryComponentDataType");
      this.dateTypeList = result;
      this.queryHeader();
    },
    async queryHeader() {
      const { result } = await this.$store.dispatch("queryStoreVisualize", {
        configId: this.id,
        layoutType: "ssrTemplate",
        pageNo: 1,
        pageSize: 10
      });
      console.log("result: ", result);
      if (result.records.length) {
        this.templateList = result.records;
        this.selectTemplate = result.records[0];
        this.checkTemplate();
      } else {
        this.dialogVisible = true;
      }
    },
    checkTemplate() {
      let tableHeader = JSON.parse(this.selectTemplate.layoutComponents);
      this.configId = this.selectTemplate.configId;
      this.header(tableHeader);
    },
    header(tableHeader) {
      let headerList = [];
      this.dateType = JSON.parse(JSON.stringify(tableHeader.dateType));
      this.textList = JSON.parse(JSON.stringify(tableHeader.textList));

      this.valueList = JSON.parse(JSON.stringify(tableHeader.valueList));
      this.dateList = JSON.parse(JSON.stringify(tableHeader.dateList));

      this.textList.forEach(v => {
        v.children = [];
      });
      this.valueList.forEach(v => {
        v.children = [];
      });

      headerList.push(...this.textList);

      if (this.dateType) {
        let name = this.dateTypeList.find(v => v.itemValue === this.dateType);

        headerList.push({
          labelName: name.itemText,
          columnName: this.dateType,
          children: this.valueList
        });
      } else {
        headerList.push(...this.valueList);
      }
      this.tableHeader = [];
      this.tableData = [];

      setTimeout(() => {
        this.tableHeader = headerList;
        this.$nextTick(() => {
          //解决表头与内容错位
          this.$refs.table.doLayout();
        });
      }, 100);
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss">
.not-add-header {
  padding: 10px 20px;
  background: #f7f7f7;
  min-height: 100px;
  .title {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #222;
  }
}
.title {
  margin-bottom: 20px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.box {
  padding: 10px;
}
.ctmd {
  position: relative;
  .edit {
    position: absolute;
    top: -30px;
    right: 0;
    left: 0;
  }
}
</style>
